import React from 'react';
import Button from '@material-ui/core/Button';

const REPORT_CARDS = [
  {
    id: 'pii',
    title: 'PII Report',
    icon: 'security',
    description: 'Tables and columns containing PII with sensitivity classification levels.',
    color: '#e53935',
  },
  {
    id: 'aiEligible',
    title: 'AI Sensitive Report',
    icon: 'smart_toy',
    description: 'Datasets flagged as AI-sensitive, requiring special handling for AI/ML training and inference use.',
    color: '#1976d2',
  },
  {
    id: 'ownership',
    title: 'Ownership & Stewardship',
    icon: 'people',
    description: 'Asset-level owner, steward assignments and flagged unowned (orphaned) assets.',
    color: '#388e3c',
  },
  {
    id: 'schemaAudit',
    title: 'Schema Change / Audit',
    icon: 'history',
    description: 'DDL changes over time — added, dropped, and altered columns per table.',
    color: '#f57c00',
  },
  {
    id: 'usage',
    title: 'Usage / Access Report',
    icon: 'bar_chart',
    description: 'Most and least queried tables; dormant data candidates (>90d inactive).',
    color: '#7b1fa2',
  },
];

function ReportsGrid({ onSelectReport }) {
  return (
    <div className="dd-reports-grid">
      {REPORT_CARDS.map((card) => (
        <div key={card.id} className="dd-report-card">
          <div className="dd-report-card-header" style={{ borderColor: card.color }}>
            <i className="material-icons dd-report-card-icon" style={{ color: card.color }}>{card.icon}</i>
            <h3 className="dd-report-card-title">{card.title}</h3>
          </div>
          <p className="dd-report-card-desc">{card.description}</p>
          <div className="dd-report-card-footer">
            <Button
              variant="outlined"
              size="small"
              onClick={() => onSelectReport(card.id)}
              style={{ color: card.color, borderColor: card.color }}
              endIcon={<i className="material-icons" style={{ fontSize: 16 }}>arrow_forward</i>}
            >
              View
            </Button>
          </div>
        </div>
      ))}
    </div>
  );
}

export default ReportsGrid;
